module.exports = __webpack_public_path__ + "997186c4bde075ada02d1a2f1cb3cee0.png";